import * as jsxRuntime from "C:\\Users\\admin\\english version Amalie ai\\update 1\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment